/* tslint:disable */
/* eslint-disable */
/**
 * Optimizely Private Flags API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    EnvironmentValidationView,
    EnvironmentValidationViewFromJSON,
    EnvironmentValidationViewToJSON,
    ErrorResponse,
    ErrorResponseFromJSON,
    ErrorResponseToJSON,
    ProblemDetail,
    ProblemDetailFromJSON,
    ProblemDetailToJSON,
} from '../models';

export interface ValidateEnvironmentRequest {
    project_id: number;
    environment_id: string;
}

/**
 * no description
 */
export class EnvironmentsPrivateApi extends runtime.BaseAPI {

    /**
     * Requires a token provided in the Authorization header or opp_session cookie. 
     * Validate if the environment exists for the given project ID.
     */
    async validateEnvironmentRaw(requestParameters: ValidateEnvironmentRequest): Promise<runtime.ApiResponse<EnvironmentValidationView>> {
        if (requestParameters.project_id === null || requestParameters.project_id === undefined) {
            throw new runtime.RequiredError('project_id','Required parameter requestParameters.project_id was null or undefined when calling validateEnvironment.');
        }

        if (requestParameters.environment_id === null || requestParameters.environment_id === undefined) {
            throw new runtime.RequiredError('environment_id','Required parameter requestParameters.environment_id was null or undefined when calling validateEnvironment.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/internal/projects/{project_id}/environments/{environment_id}/validate`.replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters.project_id))).replace(`{${"environment_id"}}`, encodeURIComponent(String(requestParameters.environment_id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => EnvironmentValidationViewFromJSON(jsonValue));
    }

    /**
     * Requires a token provided in the Authorization header or opp_session cookie. 
     * Validate if the environment exists for the given project ID.
     */
    async validateEnvironment(requestParameters: ValidateEnvironmentRequest): Promise<EnvironmentValidationView> {
        const response = await this.validateEnvironmentRaw(requestParameters);
        return await response.value();
    }

}
